import { useCallback, useEffect, useState } from 'react';
import outboundDraftsService from '../api/services/outboundDrafts';
import { pendingCount } from '../pages/Admin/ReviewQueue/draftPresentation';

const REFRESH_INTERVAL_MS = 60_000;

/**
 * How many outbound drafts are still waiting on an admin, for the nav badge.
 *
 * Only polls when `enabled` — a customer has no review queue, and asking for
 * one would just draw a 403 on every navigation.
 */
export default function useReviewQueueCount(enabled: boolean): number {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return;
    }
    try {
      const drafts = await outboundDraftsService.find();
      setCount(pendingCount(Array.isArray(drafts) ? drafts : []));
    } catch (error) {
      // A badge is not worth surfacing an error over; leave the last count.
      console.error('Failed to load the review queue count', error);
    }
  }, [enabled]);

  useEffect(() => {
    load();
    if (!enabled) return undefined;
    const interval = setInterval(load, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [enabled, load]);

  return count;
}
